import {
  CLEAR_CITY_BIKES,
  GET_CITY_BIKES
} from '../constants/cityBikes';

export const getCityBikes = (queryParams) => ({
  type: GET_CITY_BIKES,
  meta: {
    method: 'GET',
    queryParams: {
      ...queryParams,
      page_size: 16
    },
    endpoint: 'bikes/'
  }
});

export const clearCityBikes = () => ({
  type: CLEAR_CITY_BIKES
});



// WEBPACK FOOTER //
// ./src/actions/cityBikes.js